import getUUID from '@gcloud-npm/utils.monitoring.get-uuid';
import Sonda from '@gcloud-npm/utils.monitoring.sonda';
import Request from '@gcloud-npm/utils.request';
import calculateHeaderParams from '@gcloud-npm/node.build-process.build-environments';
import { PROCESS_NAME, FAMILY_API } from './constants';

const PATH = 'https://sa2m.col.movistar.es/rules/evaluate';
const EVENT_NAME = 'LAYER_FORM.SAM_TEST_AB';

const getTestVersionSam = ({
  data,
  context,
  idFront = 'VT',
  build = false,
}) => {
  const idRequest = getUUID(idFront);
  const sonda = new Sonda({
    eventName: EVENT_NAME,
    context,
    uniqueId: idRequest,
    origin: PROCESS_NAME,
  });
  const URL_API = `${PATH}`;
  const headers2Use = calculateHeaderParams(build, FAMILY_API, context);
  const request = new Request({
    method: 'POST',
    endpoint: URL_API,
    headers: {
      ...headers2Use,
      withCredentials: true,
      'Content-Type': 'application/json',
    },
    sonda,
    data,
  });
  return request.makeRequest();
};

export default getTestVersionSam;
